// PostFx
// Features:
// - Manages post-processing effect chain
// - Includes Bloom, Vignette, and custom PaintPass (watercolor effect)

import { EffectComposer, Bloom, Vignette } from '@react-three/postprocessing'
import { extend } from '@react-three/fiber'
import { useTexture } from '@react-three/drei'
import * as THREE from 'three'

import { PaintPass } from './PaintPass'
import paperTextureURL from '/textures/paper.jpg'

extend({ PaintPass })

export default function PostFx() {
    const watercolorTexture = useTexture(paperTextureURL, (t) => {
        t.minFilter = THREE.LinearMipmapLinearFilter
        t.magFilter = THREE.LinearFilter
        t.generateMipmaps = true
    })

    return (
        <EffectComposer
            enableNormalPass={false}
            multisampling={0}
            autoClear={false}
        >
            <Bloom mipmapBlur />
            <Vignette opacity={1.0} offset={0.0} darkness={0.5} />
            <paintPass args={[{ watercolorTexture }]} />
        </EffectComposer>
    )
}
